import OpenFileModal from './OpenFileModal';

export default OpenFileModal;
